import BaseService from "../base.service";

class SurveyQuestionService extends BaseService {
  constructor() {
    super("survey-questions");
  }
}

export default new SurveyQuestionService();
